<svg-icon
	src="{{ icon }}"
	aria-hidden="true"
	focusable="false"
	[style.line-height]="'100%'"
	[ngClass]="iconClass"
></svg-icon>
